import {qs} from '../qs'

const BASE_PATH = '/audit/manual'

export default {
  getAuditSiteDevices: query => ({
    url: `${BASE_PATH}/site/device/info${qs(query, '?')}`,
    method: 'GET'
  }),
  getAuditDataBySiteDevice: (siteDeviceId, conditions) => ({
    url: `${BASE_PATH}/data/list/${siteDeviceId}${qs(conditions, '?')}`,
    method: 'GET'
  }),
  updateAuditFlag: data => ({
    url: `${BASE_PATH}/data/60`,
    method: 'PUT',
    data
  }),
  submit: data => ({
    url: `${BASE_PATH}/data/submits`,
    method: 'PUT',
    data
  }),
  backReAudit: data => ({
    url: `${BASE_PATH}/data/back`,
    method: 'PUT',
    data
  }),
  getLog: data => ({
    url: `${BASE_PATH}/log`,
    method: 'POST',
    data
  }),
  getDetail: (auditId) => ({
    url: `${BASE_PATH}/${auditId}`,
    method: 'GET'
  }),
  getCalendar: (siteDeviceId, dateTime) => ({
    url: `${BASE_PATH}/calendar?siteDeviceId=${siteDeviceId}&dateTime=${dateTime}`,
    method: 'GET'
  }),
  getRatio: (siteDeviceId, dateTime) => ({
    url: `${BASE_PATH}/ratio/?auditTime=${dateTime}&siteDeviceId=${siteDeviceId}`,
    method: 'GET'
  }),
  getMonthAuditStatus: query => ({
    url: `${BASE_PATH}/status${qs(query, '?')}`,
    method: 'GET'
  }),
  backAudited: auditId => ({
    url: `${BASE_PATH}/end/data/back/${auditId}`,
    method: 'PUT'
  }),
  checkMonthAudit: query => ({
    url: `audit/month/check${qs(query, '?')}`,
    method: 'GET'
  }),
  saveMonthAudit: data => ({
    url: `audit/month`,
    method: 'POST',
    data
  }),
  getMonthAuditList: query => ({
    url: `audit/month${qs(query, '?')}`,
    method: 'GET'
  }),
  reGenHourData: data => ({
    url: `/audit/manual/regenerates/hourly/data`,
    method: 'PUT',
    data
  }),
  restoreHourData: data => ({
    url: `/audit/manual/restore/hourly/data`,
    method: 'PUT',
    data
  }),
  getShowBigScreenFlag: query => ({
    url: `/audit/manual/get/big/screen${qs(query, '?')}`,
    method: 'GET'
  }),
  setBigScreen: (data) => ({
    url: `/audit/manual/big/screen`,
    method: 'PUT',
    data
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Audit.js